import { motion } from "framer-motion";
import { WHY_HIRE } from "@/data/site";
import { MaskedLines } from "@/components/Kinetic";
import { EASE, viewport } from "@/lib/motion";

export const WhyHire = () => (
  <section
    data-testid="why-hire"
    className="relative border-t border-[#1f1f1f] bg-[#0a0a0a] py-20 md:py-32"
  >
    <div className="mx-auto max-w-[1700px] px-5 md:px-10">
      <div className="grid gap-8 lg:grid-cols-12 lg:items-end">
        <MaskedLines
          lines={["WHY HAND ME", "YOUR FOOTAGE."]}
          className="font-display text-[11vw] font-black uppercase leading-[0.87] tracking-[-0.04em] text-[#e5e5e5] sm:text-5xl lg:col-span-7 lg:text-[4vw]"
          testId="why-hire-headline"
        />
        <p className="max-w-md text-sm leading-relaxed text-[#a3a3a3] lg:col-span-5 md:text-base">
          Three reasons a creator or a brand keeps sending the next project.
        </p>
      </div>

      <div className="mt-14 grid gap-px bg-[#1f1f1f] md:mt-20 md:grid-cols-3">
        {WHY_HIRE.map((w, i) => (
          <motion.div
            key={w.num}
            initial={{ opacity: 0, y: 34 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={viewport}
            transition={{ duration: 0.85, ease: EASE, delay: i * 0.1 }}
            data-testid={`why-hire-${w.num}`}
            className="group relative bg-[#0d0d0d] p-7 transition-colors duration-500 hover:bg-[#111111] md:p-10 lg:p-12"
          >
            <span className="font-mono text-xs tracking-[0.2em] text-[#d4ff00]">
              {w.num}
            </span>
            <h3 className="mt-6 font-display text-3xl font-black uppercase tracking-[-0.03em] text-[#e5e5e5] md:text-4xl">
              {w.title}
            </h3>
            <p className="mt-5 font-display text-base font-bold leading-snug text-[#e5e5e5] md:text-lg">
              {w.line}
            </p>
            <p className="mt-4 text-sm leading-relaxed text-[#a3a3a3]">
              {w.body}
            </p>
            <span className="mt-8 block h-[2px] w-10 bg-[#1f1f1f] transition-all duration-500 group-hover:w-20 group-hover:bg-[#d4ff00]" />
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
